import React from "react";
import { MATERIAL_CATALOG } from "../lib/walls";
import HatchDefs from "./HatchDefs";

/**
 * V1.8.8 — Wall Type Schedule legend.
 *
 * Floating panel pinned to the BOTTOM-LEFT of the 2D Plan view. Auto-shows
 * when the floor has 1+ wall segments (i.e. always, since rooms always
 * produce perimeter walls). Each row = one schedule tag (WT1, WT2, …)
 * with a hatched swatch + the material label + thickness in inches/mm.
 *
 * Mirrors the visual language of MaterialLegend (fixtures) but for walls.
 */

const M_TO_IN = 39.3701;
const fmtThickness = (m) => {
  if (!Number.isFinite(m) || m <= 0) return "";
  const inches = Math.round(m * M_TO_IN);
  return `${inches}"`;
};

export default function WallTypeLegend({ schedule, isArch }) {
  if (!schedule || schedule.length === 0) return null;
  return (
    <div
      data-testid="floor-plan-wall-schedule"
      className={
        "absolute bottom-3 left-3 z-10 max-w-[260px] border shadow-sm font-mono text-[10px] " +
        (isArch
          ? "bg-[#f5efe1]/95 border-zinc-400 text-zinc-700"
          : "bg-zinc-950/85 border-zinc-700 text-zinc-200 backdrop-blur-md")
      }
    >
      <div
        className={
          "px-3 py-1.5 border-b uppercase tracking-widest " +
          (isArch
            ? "border-zinc-400 text-zinc-600 bg-[#ebe2cd]"
            : "border-zinc-700 text-brass-400 bg-zinc-900")
        }
      >
        // Wall Type Schedule
      </div>
      <div className="px-2 py-1.5 space-y-1.5">
        {schedule.map((row) => {
          const cat = MATERIAL_CATALOG[row.material] || {};
          return (
            <div
              key={row.tag}
              data-testid={`wall-schedule-row-${row.tag}`}
              className="flex items-center gap-2"
            >
              <svg
                width="24"
                height="12"
                viewBox="0 0 24 12"
                style={{ flexShrink: 0 }}
              >
                <HatchDefs mode={isArch ? "architectural" : "diagram"} />
                <rect
                  x="0"
                  y="0"
                  width="24"
                  height="12"
                  fill={isArch ? "#ffffff" : "#0c0a09"}
                  stroke={isArch ? "#1f2937" : "#a8a29e"}
                  strokeWidth="0.7"
                />
                <rect
                  x="0"
                  y="0"
                  width="24"
                  height="12"
                  fill={`url(#${cat.hatch})`}
                  opacity="0.95"
                />
              </svg>
              <span
                className={
                  "px-1 border " +
                  (isArch
                    ? "border-amber-700 bg-amber-100 text-amber-900"
                    : "border-brass-600 bg-brass-950 text-brass-300")
                }
                style={{ fontSize: 9, letterSpacing: 0.5, fontWeight: 700 }}
              >
                {row.tag}
              </span>
              <div className="flex-1 min-w-0">
                <div className={isArch ? "text-zinc-800" : "text-zinc-100"}>
                  {row.label}
                </div>
                <div className={isArch ? "text-zinc-500" : "text-zinc-400"}>
                  {row.kind === "exterior" ? "Exterior" : "Interior"} · {fmtThickness(row.thickness_m)}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
